import { render, staticRenderFns } from "./AddAdditive.vue?vue&type=template&id=bdacbf66&"
import script from "./AddAdditive.vue?vue&type=script&lang=js&"
export * from "./AddAdditive.vue?vue&type=script&lang=js&"
import style0 from "./AddAdditive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports